import axiosClient from "./axiosClient";
import { RecipientResponse } from "../types/recipient";

export const getIntercomUsersByUrlId = (urlId: string) => {
  return axiosClient.get<RecipientResponse>(
    `/intercoms/${urlId}/users`
  );
};

export const requestCallReq = async (recipient_id: number, url_id: string) => {
  return axiosClient.put(`/intercoms/${url_id}/request-call`, { recipient_id });
};
